import { toast } from "sonner";
import { Copy, Share2 } from "lucide-react";
import { API } from "@/lib/api";

export const shareLink = (id) => `${API}/s/${id}`;

const NETWORKS = [
  { id: "x", label: "X", url: (u, t) => `https://twitter.com/intent/tweet?url=${u}&text=${t}` },
  { id: "facebook", label: "Facebook", url: (u) => `https://www.facebook.com/sharer/sharer.php?u=${u}` },
  { id: "whatsapp", label: "WhatsApp", url: (u, t) => `https://wa.me/?text=${t}%20${u}` },
  { id: "pinterest", label: "Pinterest", url: (u, t) => `https://pinterest.com/pin/create/button/?url=${u}&description=${t}` },
];

export const ShareButtons = ({ id, text, link: customLink, title = "Share this glow-up" }) => {
  const link = customLink || shareLink(id);
  const u = encodeURIComponent(link);
  const t = encodeURIComponent(text);

  const copy = async () => {
    try { await navigator.clipboard.writeText(link); toast.success("Link copied!"); }
    catch { toast.error("Couldn't copy link"); }
  };
  const native = async () => {
    try { await navigator.share({ title: text, url: link }); }
    catch (e) { if (e?.name !== "AbortError") toast.error("Sharing isn't available here. Copy the link instead."); }
  };

  return (
    <div className="rounded-3xl bg-white border border-[#EAE3D9] p-5" data-testid="share-panel">
      <p className="font-display font-semibold">{title}</p>
      <div className="mt-3 flex items-center gap-2 rounded-xl bg-[#FAF7F2] border border-[#EAE3D9] p-1.5 pl-3">
        <span className="flex-1 truncate font-mono text-xs" data-testid="share-link-text">{link}</span>
        <button onClick={copy} data-testid="share-copy-button" className="flex items-center gap-1 rounded-lg bg-[#1E1B26] text-white px-3 py-1.5 text-xs font-bold hover:bg-[#FF5A79] transition-colors"><Copy className="h-3.5 w-3.5" /> Copy</button>
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        {NETWORKS.map((n) => (
          <a key={n.id} href={n.url(u, t)} target="_blank" rel="noopener noreferrer" data-testid={`share-${n.id}-button`}
            className="rounded-full border border-[#EAE3D9] px-3.5 py-1.5 text-sm font-semibold hover:border-[#1E1B26] transition-colors">{n.label}</a>
        ))}
        {typeof navigator !== "undefined" && navigator.share && (
          <button onClick={native} data-testid="share-native-button" className="flex items-center gap-1 rounded-full border border-[#EAE3D9] px-3.5 py-1.5 text-sm font-semibold hover:border-[#1E1B26]"><Share2 className="h-3.5 w-3.5" /> More</button>
        )}
      </div>
    </div>
  );
};
